import { render, staticRenderFns } from "./crm.vue?vue&type=template&id=6787ac4e&lang=html&"
import script from "./crm.vue?vue&type=script&lang=js&"
export * from "./crm.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/service.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "crm.vue"
export default component.exports